<template>
  <v-row align="center" justify="center">
    <v-img
      :src="uploadLink"
      lazy-src="@/assets/image-placeholder.png"
      aspect-ratio="1"
      class="grey lighten-2"
      contain
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @load="linkLoaded = true"
    >
      <template v-if="linkLoaded && hover" v-slot:default>
        <v-row class="fill-height ma-0 darken" align="center" justify="center">
          <div class="">
            <v-btn color="gray" @click="startUploadImage">Edytuj</v-btn>
          </div>
        </v-row>
      </template>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <ImageUpload
      :show="showUpload"
      title="Prześlij obraz"
      @close="showUpload = false"
      @uploaded="uploadImage"
      @disableOutsideClick="disableOutsideClick"
      @enableOutsideClick="enableOutsideClick"
    />
  </v-row>
</template>

<script>
import ImageUpload from '@/components/shared/ImageUpload.vue';
import MediaApi from '@/api/mediaApi';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    ImageUpload
  },
  props: {
    lesson: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      hover: false,
      showUpload: false,
      uploadLink: '',
      linkLoaded: false
    };
  },
  computed: mapAccountState(['token']),
  watch: {
    showUpload(val) {
      if (val) {
        this.$emit('disableOutsideClick');
      } else {
        this.$emit('enableOutsideClick');
      }
    }
  },
  async mounted() {
    try {
      if (this.lesson.url) {
        const response = await new MediaApi(this.token).get(this.lesson.url);
        this.uploadLink = `${response.data.result.uri}${response.data.result.sasBlobToken}`;
      } else {
        this.uploadLink = require('@/assets/image-placeholder.png');
      }
    } catch (err) {
      console.error(err);
      // TODO: handle
    }
  },
  methods: {
    startUploadImage() {
      this.showUpload = true;
    },
    uploadImage(ev) {
      this.$emit('change', { type: this.lesson.type, value: ev.url });
      new MediaApi(this.token).get(ev.url).then(
        response => (this.uploadLink = `${response.data.result.uri}${response.data.result.sasBlobToken}`),
        err => {
          console.error(err);
          // TODO: handle
        }
      );
    },
    disableOutsideClick() {
      this.$emit('disableOutsideClick');
    },
    enableOutsideClick(ev) {
      this.$emit('enableOutsideClick', ev);
    }
  }
};
</script>

<style lang="scss" scoped>
.darken {
  background: rgba(0, 0, 0, 0.5);
}
</style>
